// Third-Party Library
import moment from "moment"

const dateConvert = value => {
  const data = new Date(value)

  return {
    default: {
      format: moment(data).format("YYYY-MM-DD"),
      format2: moment(data).format("MM/DD/YYYY"),
      detail: moment(data).format("D MMMM YYYY")
    },
    withDay: {
      detail: moment(data).format("dddd, D MMMM YYYY")
    }
  }
}

export default dateConvert